//
// Software Name: Orange Design System Charts
// SPDX-FileCopyrightText: Copyright (c) 2023 - 2026 Orange SA
// SPDX-License-Identifier: MIT
//
// This software is distributed under the MIT license.
//
export const DEFAULT_COLORS_PURPLE = {
    color: [
        'var(--ods-purple-1, #492191)',
        'var(--ods-purple-2, #6E4AA7)',
        'var(--ods-purple-3, #9373BD)',
        'var(--ods-purple-4, #A885D8)',
        'var(--ods-purple-5, #C1A4E4)',
        'var(--ods-purple-6, #D9C2F0)',
    ],
};
